import { values } from "lodash";

import untypedItems from "@data/items.json";

import type { ItemsJson } from "@typings/product/item";

const items: ItemsJson = untypedItems as ItemsJson;

export default () => {
  return values(items).filter((i) => i.category.name !== "Free Gift");
};
